import React, { Component, Fragment } from "react";
import { Card, Row, Col, Select } from "antd";
import WizardFooter from "./wizard-footer";
import { Translate } from "react-translated";
import WizardPager from "../../../components/wizard-pager";

const Option = Select.Option;

class Step extends Component {
  render() {
    const { wizard, updateField, handleBlur, updateRadioBtnToggle } = this.props;
    // Direct container reference to override App.js configuration
    const getCustomContainer = () => document.body;

    return (
      <Fragment>
        <div className="stepBody">
          <Card className="step2_1">
            <h5 className="headingText">"How many children/dependents do you have living at home or away at college ?”</h5>
            <Select
              value={typeof wizard.children === "number" ? wizard.children : 0}
              style={{ width: 220 }}
              getPopupContainer={getCustomContainer}
              onChange={(value) => {
                updateField("children", value);
                if (!this.props.isExternalBFile) {
                  updateRadioBtnToggle();
                }
              }
              }
            >
              {/* <Option value={null}><Translate text={`Select`} />...</Option> */}

              {[...Array(11)].map((x, i) => (
                <Option value={i} key={i}>
                  {i}
                </Option>
              ))}
            </Select>
            <Row style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }} className='center'>
              <Col xs={24} sm={20} md={16} lg={12} xl={10} className='didyouKnowSection'>
                {/* <img src={require("./images/didyouKnow.png")} width={120} className='imgdid' /> */}
                <img src={require('./images/didYouKnowBulb.jpg')} width={40} alt='' />
                <h4>Did You Know</h4>
                <p className="textContent">“If the student is not taking a car to school, It is not the right choice to remove the child from an existing auto policy to reduce costs.”</p>
              </Col>
            </Row>
            {/* <WizardFooter {...this.props} /> */}
          </Card>
        </div>
        <div className='stepFooter'>
          <WizardFooter {...this.props} />
        </div>
      </Fragment>
    );
  }
}

export default Step;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/step2_1_updated.js